import request from '@/utils/request'

const api = {
  login: '/auth/login',
  getAppConfig: '/dashboard/get',
  getIntegrations: '/dashboard/integrations',
  saveAppConfig: '/dashboard/save',
  webhookList: '/webhook-task/list',
  repush: '/webhook-task/repush',
  userInfo: '/user/info',
  userSave: '/user/save',
  historyPush: '/order/history-push',
  queryOrder: '/order/query-order',
  createParcel: '/send-cloud/create-parcel'
}

/**
 *  用户登录
 * @param data
 */
export function login (data) {
  return request({
    url: api.login,
    method: 'post',
    data: data
  })
}

/**
 * 获取配置
 */
export function getAppConfig () {
  return request({
    url: api.getAppConfig,
    method: 'get'
  })
}

/**
 * 获取集成
 */
export function getIntegrations (username, password) {
  return request({
    url: api.getIntegrations,
    method: 'get',
    params: {
      username,
      password
    }
  })
}

/**
 * 保存配置
 * @param data
 */
export function saveAppConfig (data) {
  return request({
    url: api.saveAppConfig,
    method: 'post',
    data: data
  })
}

/**
 *  任务分页
 * @param data
 */
export function webhookList (data) {
  return request({
    url: api.webhookList,
    method: 'post',
    data: data
  })
}

/**
 * 重新推送
 * @param data
 */
export function repush (data) {
  return request({
    url: api.repush,
    method: 'post',
    data: data
  })
}

/**
 * 拿用户信息
 */
export function userInfo () {
  return request({
    url: api.userInfo,
    method: 'get'
  })
}

/**
 * 保存用户信息
 * @param data
 */
export function userSave (data) {
  return request({
    url: api.userSave,
    method: 'post',
    data: data
  })
}

/**
 * 历史订单推送
 * @param data
 */
export function historyPush (data) {
  return request({
    url: api.historyPush,
    method: 'post',
    data: data
  })
}

/**
 * 查询订单
 * @param data
 */
export function queryOrder (data) {
  return request({
    url: api.queryOrder,
    method: 'post',
    data: data
  })
}

/**
 * 创建包裹
 * @param data
 */
export function createParcel (data) {
  return request({
    url: api.createParcel,
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/api.js